import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

Sentry.init({
  dsn: 'https://8e6c1235b83eb922c7cce4803fa6b7ee@o4510551288774656.ingest.de.sentry.io/4510551293362256',
  tunnel: '/quotes-api/exception/',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, maskAllInputs: true }),
    Sentry.browserSessionIntegration({ lifecycle: 'page' }),
  ],
  environment: environment.environmentName,
  release: `tangible-frontend:${environment.buildShortSha}`,
  tracesSampleRate: 0.1,
  tracePropagationTargets: ['/quotes-api', 'localhost', /^\//],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
